import { buildQuery } from '@/utils/helpers'
import fetcher from '../fetcher'

export const GET_CITY_LIST = `
  query getCity($country_id: String,$addressType:String) {
  citys(country_id: $country_id,addressType:$addressType) {
    listcitys {
      city_id
      code
      country_id
      default_name
      disable_on_storefront
    }
  }
}
`
export const GET_WARDS_LIST = `
    query getWards($district_id: String,$addressType:String) {
    wards(district_id: $district_id,addressType:$addressType) {
      listwards {
        code
        default_name
        disable_on_storefront
        district_id
        ward_id
      }
    }
  }
`
export const GET_DISTRICT_LIST = `
  query getDistrict($city_id: String,$addressType:String) {
  districts(city_id: $city_id,addressType:$addressType) {
    listdistricts {
      city_id
      code
      default_name
      disable_on_storefront
      district_id
    }
  }
}
`

export const GET_CITY = `
  query getCity($locationType: String!, $addressType: String!) {
    Locations(locationType: $locationType, addressType: $addressType) {
      items {
        id
        name
        parentId
      }
    }
  }
`

export const GET_DISTRICT = `
  query getDistrict($parentId: Int, $locationType: String!, $addressType: String!) {
    Locations(parentId: $parentId, locationType: $locationType, addressType: $addressType) {
      items {
        id
        name
        parentId
      }
    }
  }
`

export const GET_WARD = `
  query getWard($parentId: Int, $locationType: String!, $addressType: String!) {
    Locations(parentId: $parentId, locationType: $locationType, addressType: $addressType) {
      items {
        id
        name
        parentId
      }
    }
  }
`

export const CREATE_ADDRESS = `
mutation createCustomerAddress($input: CustomerAddressInput!) {
  createCustomerAddress(input: $input) {
    id
  }
}
`
export const DELETE_ADDRESS = `
mutation deleteCustomerAddress($id: Int!) {
  deleteCustomerAddress(id: $id)
}
`
export const UPDATE_ADDRESS = `
mutation updateCustomerAddress(
  $addressId: Int!
  $input: CustomerAddressInput!
) {
  updateCustomerAddress(id: $addressId, input: $input) {
    id
  }
}
`

export const location = {
  getDistricts: async (id: string | number, addressType: string) => {
    if (!id) return
    const districts = await fetcher.get(buildQuery(GET_DISTRICT_LIST, { city_id: id, addressType }), {
      next: { tags: ['district', id.toString()] },
    })
    return districts?.payload?.data?.districts?.listdistricts as District[]
  },
  getWards: async (id: string | number, addressType: string) => {
    if (!id) return
    const wards = await fetcher.get(buildQuery(GET_WARDS_LIST, { district_id: id, addressType }), {
      next: { tags: ['ward', id as string] },
    })
    return wards?.payload?.data?.wards?.listwards as Ward[]
  },
  listCities: async ({ addressType }: { addressType: string }) => {
    const cities = await fetcher.get(buildQuery(GET_CITY_LIST, { country_id: 'VN', addressType }), {
      next: { tags: ['city', addressType] },
    })
    return cities?.payload?.data?.citys?.listcitys as City[]
  },

  getOldDistricts: async (id: string | number) => {
    if (!id) return
    const districts = await fetcher.get(
      buildQuery(GET_DISTRICT, { parentId: id, locationType: 'DISTRICT', addressType: '2024' }),
      {
        next: { tags: ['districtOld', id.toString()] },
      }
    )
    return districts?.payload?.data?.Locations?.items as TOldLocation[]
  },
  getOldWards: async (id: string | number) => {
    if (!id) return
    const wards = await fetcher.get(
      buildQuery(GET_WARD, { parentId: id, locationType: 'WARD', addressType: '2024' }),
      {
        next: { tags: ['wardOld', id as string] },
      }
    )
    return wards?.payload?.data?.Locations?.items as TOldLocation[]
  },
  listOldCities: async () => {
    const cities = await fetcher.get(buildQuery(GET_CITY, { locationType: 'CITY', addressType: '2024' }), {
      next: { tags: ['cityOld'] },
    })
    return cities?.payload?.data?.Locations?.items as TOldLocation[]
  },
}
